// @core/api/endpoints/attachment/list_attachments_by_owner.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListAttachmentsResponse,
} from '../../../types/attachment';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/attachment';

/**
 * List attachments by owner
 * Returns a paginated list of attachments owned by a specific user. Supports filtering by attachment type via query parameter.
 */
export async function ListAttachmentsByOwner(
  owner_id: string,
  params?: PaginatedRequest & {
    type?: string | number | boolean;
  },
  options?: RequestOptions
): Promise<ListAttachmentsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/attachments/owner/:owner_id`;
  requestPath = requestPath.replace(':owner_id', encodeURIComponent(owner_id));
  const requestOptions = options;
  return client.get<ListAttachmentsResponse>(requestPath, { ...requestOptions, params });
}
